import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu, Icon, Popup } from 'semantic-ui-react';
import { colorsModeUI } from '../../../modeUI';

import './index.css';

/**
 * Menu item
 * Parameters (Props):
 * @props string key
 * @props string icon
 * @props object cornerIcon => object type cornerIcon component
 * @props string label
 * @props string tooltip
 * @props func onClick
 * @props bool active
 * @props bool showTooltips
 * @props bool showLabels
 * @props string mode
 */
export default class MenuItem extends Component {
  constructor(props) {
    super(props);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * On mouse leave
   */
  onMouseLeave() {
    this.setState({ hover: false });
  }

  /**
   * On mouse enter
   */
  onMouseEnter() {
    this.setState({ hover: true });
  }

  render() {
    const {
      icon,
      cornerIcon,
      label,
      tooltip,
      onClick,
      active,
      showTooltips,
      showLabels,
      mode,
    } = this.props;

    const { hover } = this.state;
    const styleItemMenu = {};
    const styleItemMenuActive = {};
    const styleBarItemMenuActive = {};
    let iconCornerColor;
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      styleItemMenu.color = colors.SIDER_BAR_MENU_COLOR;
      styleItemMenuActive.color = colors.SIDER_BAR_MENU_ITEM_ACTIVE_COLOR;
      styleBarItemMenuActive.backgroundColor =
        colors.SIDER_BAR_MENU_ITEM_BAR_ACTIVE_COLOR;
      iconCornerColor = colors.SIDE_BAR_MENU_ICON_CORNER_COLOR;
      if (hover) {
        styleItemMenu.color = colors.SIDER_BAR_MENU_HOVER_COLOR;
        styleItemMenu.backgroundColor =
          colors.SIDER_BAR_MENU_HOVER_BACKGROUND_COLOR;
      }
    }
    let iconDisplay = <Icon name={icon} size="large" />;
    if (cornerIcon) {
      iconDisplay = (
        <div>
          <cornerIcon.type
            {...cornerIcon.props}
            {...{ color: styleItemMenu.color, iconCornerColor }}
          />
        </div>
      );
    }
    let menuItem = (
      <Menu.Item
        as="a"
        style={{ ...styleItemMenu, ...(active ? styleItemMenuActive : {}) }}
        active={active}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        {(active || hover) && (
          <div
            style={styleBarItemMenuActive}
            className={`item-active-bar ${showLabels && 'labels'}`}
          >
            {''}
          </div>
        )}
        {showTooltips && tooltip ? (
          <Popup
            trigger={iconDisplay}
            content={tooltip}
            position="bottom right"
            className="sidebar-item"
          />
        ) : (
          iconDisplay
        )}
        {showLabels && label}
      </Menu.Item>
    );
    menuItem = (
      <menuItem.type
        {...menuItem.props}
        {...(onClick ? { onClick } : {})}
      />
    );
    return menuItem;
  }
}

MenuItem.propTypes = {
  icon: PropTypes.string,
  cornerIcon: PropTypes.objectOf(PropTypes.object),
  label: PropTypes.string,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  showTooltips: PropTypes.bool,
  showLabels: PropTypes.bool,
  mode: PropTypes.string,
};

MenuItem.defaultProps = {
  icon: null,
  cornerIcon: null,
  label: null,
  tooltip: null,
  onClick: null,
  active: false,
  showTooltips: false,
  showLabels: false,
  mode: null,
};
